
import React, { use, useState } from "react";

import { AddDesignationSer } from "./Services/AddDesignationSer";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

import * as bootstrap from 'bootstrap';

import axios from "axios";
const AddDesignations = () => {

  const [editDepartmentName, setEditDepartmentName] = useState('');


  const [editDropdownDesignation, setEditDropdownDesignation] = useState('');
  const [editInputDesignation, setEditInputDesignation] = useState('');
  const [editDepartmentId, setEditDepartmentId] = useState(null);

  const [departments, setDepartments] = useState([]);
  const [department, setDepartment] = useState("");
  const [editableDesignationName, setEditableDesignationName] = useState('');
  const [selectedDesignationId, setSelectedDesignationId] = useState(null);
  // const [deleteId, setDeleteId] = useState(null);
  const [designationToDelete, setDesignationToDelete] = useState(null);


  useEffect(() => {
    const scriptUrls = [
      'assets/js/jquery.min.js',
      'assets/js/bootstrap.bundle.min.js',
      'assets/js/moment.min.js',
      'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
      'assets/vendor/overlay-scroll/custom-scrollbar.js',
      'assets/vendor/daterange/daterange.js',
      'assets/vendor/daterange/custom-daterange.js',
      'assets/vendor/jquery-ui/jquery-ui.min.js',
      'assets/vendor/jquery-ui/custom.js',


      'assets/vendor/datatables/dataTables.min.js',
      'assets/vendor/datatables/dataTables.bootstrap.min.js',
      'assets/vendor/datatables/custom/custom-datatables.js',
      'assets/js/custom.js'
    ];

    let isCancelled = false;

    // Load scripts sequentially
    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
      // Optionally remove scripts if needed
    };
  }, []);

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await axios.get("http://localhost:8080/webnet-hms/api/department");
        setDepartments(response.data); // Assuming the response is an array of department objects
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };

    fetchDepartments();
  }, []);

  const handleSoftDelete = (designationId) => {
    axios.delete(`http://localhost:8080/webnet-hms/api/designation/${designationId}`)
      .then((response) => {
        console.log(response)
        alert('Department marked as deleted');
        setDepartments((prevDepartments) =>
          prevDepartments.filter((dept) => dept.desigantionId !== designationId)
        ); // Remove the department from the state to hide it
      })
      .catch((error) => {
        console.error('Error marking department as deleted:', error);
      });
  };


  const [designation, setDesignation] = useState('');
  // for filling up the designation table
  const [designationTbl, setDesignationTbl] = useState([]);
  function handleEnter(e) {
    e.preventDefault();

    const requestData = {
      designation: designation,
      departmentId: department ? parseInt(department) : null,
    };

    console.log("Sending data:", requestData);

    AddDesignationSer(requestData)
      .then((response) => {
        console.log("Added:", response.data);

        // Add the new item to the local list
        setDesignationTbl((prev) => [...prev, response.data]);

        // Clear the form
        setDesignation("");
        setDepartment("");

        // Show success alert
        window.alert("Designation added successfully!");
      })
      .catch((error) => {
        console.error("Error:", error);
        window.alert("Error occurred while adding designation.");
      });
  }

  const navigator = useNavigate();
  // for filling up the department dropdown 
  useEffect(() => {
    const REST_API_BASE_URL = `http://localhost:8080/webnet-hms/api/designation`;

    const Departments = () => axios.get(REST_API_BASE_URL);
    Departments().then((response) => {
      const departmentData = response.data;
      setDepartment(departmentData);
    }).catch(error => {
      window.alert(error + " ");

    })
  }, [])


  // for filling up the designation table

  const [ids, setIds] = useState(null);
  function handleCancelDesignation(e) {
    e.preventDefault();
    let divPanel = document.getElementById('divPanel')
    divPanel.style.display = "none";
    let divButtons = document.getElementById('cancel')
    divButtons.style.display = "none";

    let addButtons = document.getElementById('add')
    addButtons.style.display = "block";


  }
  function addDesignationPanel(e) {
    e.preventDefault();
    let divPanel = document.getElementById('divPanel')
    divPanel.style.display = "block";

    let divButtons = document.getElementById('cancel')
    divButtons.style.display = "block";
    let addButtons = document.getElementById('add');
    addButtons.style.display = "none";


  }

  useEffect(() => {
    const fetchDesignations = async () => {
      try {
        const response = await axios.get("http://localhost:8080/webnet-hms/api/designation");
        setDesignationTbl(response.data);
        console.log(response);
      } catch (error) {
        console.error("Error fetching designations:", error);
      }
    };

    fetchDesignations();
  }, []);

  const handleEditSubmit = async () => {
    const designationId = Number(selectedDesignationId?.designationId || selectedDesignationId);

    if (!editableDesignationName || editableDesignationName.trim() === "") {
      window.alert("Designation cannot be empty.");
      return;
    }
    console.log("Designation ID:", editableDesignationName);

    try {
      await axios.put(`http://localhost:8080/webnet-hms/api/designation/${designationId}`, {
        designationId: designationId,
        designation: editableDesignationName,
        departmentId: editDepartmentId,
      });

      // Update designation in the local state list
      setDesignationTbl(designationTbl.map(desig =>
        desig.desigantionId === designationId
          ? { ...desig, designation: editableDesignationName }
          : desig
      ));

      alert('Designation updated successfully!');
      fetchDesignations();
         // Refresh the list after update  

    } catch (error) {
      console.error('Error updating designation:', error);
      alert('Failed to update designation');
    }
  };


  const handleEditClick = (designationId, designationName, departmentId) => {
    setSelectedDesignationId(designationId);
    setEditableDesignationName(designationName);
    setEditDepartmentId(departmentId);

    const selectedDept = departments.find(dept => dept.departmentId === departmentId);
    if (selectedDept) {
      setEditDepartmentName(selectedDept.departmentName); // Just set department name
    }
  };





  const fetchDepartment = () => {
    axios
      .get("http://localhost:8080/webnet-hms/api/department")
      .then((response) => {
        setDepartments(response.data);
      })
      .catch((error) => {
        console.error("Error fetching user types:", error);
      });
  };
  const fetchDesignations = () => {
    axios
      .get("http://localhost:8080/webnet-hms/api/designation")
      .then((response) => {
        setDesignationTbl(response.data);
      })
      .catch((error) => {
        console.error("Error fetching user types:", error);
      });
  };
  useEffect(() => {
    fetchDepartment();
    fetchDesignations();
  }, []);


  return (
    <div>
      {/* App hero header starts */}
      <div className="app-hero-header d-flex align-items-center">
        {/* Breadcrumb starts */}
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="index-2.html">
              <i className="ri-home-3-line" />
            </a>
          </li>
          <li className="breadcrumb-item">Designtions</li>
          <li className="breadcrumb-item text-primary" aria-current="page">
            Add Designtions
          </li>
        </ol>
        {/* Breadcrumb ends */}
        {/* Sales stats starts */}
        {/* <div className="ms-auto d-lg-flex d-none flex-row">
       
        {/* Sales stats ends */}
      </div>
      {/* App Hero header ends */}
      {/* App body starts */}
      <div className="app-body">
        {/* Row starts */}
        <div className="row gx-4">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                {/* Custom tabs starts */}
                <div className="custom-tabs-container">
                  {/* Nav tabs starts */}

                  {/* Nav tabs ends */}
                  {/* Tab content starts */}
                  <div className="tab-content h-350" style={{ paddingTop: "0.5rem;" }}>

                    <div className="tab-pane fade show active" id="twoA" role="tabpanel">
                      {/* Row starts */}
                      <div className="row justify-content-left">
                        <div className="col-sm-12 col-12" id="divPanel" style={{ display: "none" }}>
                          <div className="card border mb-3">
                            <div className=" card-body ">
                              <form >

                                <div className="row align-items-end g-3">
                                  <div className="col-md-4">
                                    <label className="form-label" htmlFor="a1">Department</label>
                                    <select
                                      className="form-select"
                                      id="a1"

                                      onChange={(e) => setDepartment(e.target.value)}
                                      value={department}
                                    >
                                      <option value="">Select</option>
                                      {departments.length > 0 ? (
                                        departments.map((dept) => (
                                          <option key={dept.departmentId} value={dept.departmentId}>
                                            {dept.departmentName}
                                          </option>
                                        ))
                                      ) : (
                                        <option value="">No departments available</option>
                                      )}

                                    </select>
                                  </div>

                                  <div className="col-md-4">
                                    <label className="form-label" htmlFor="a2">Designation</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="a2"
                                      placeholder="Designation"
                                      onChange={(e) => setDesignation(e.target.value)}
                                      value={designation}
                                    />
                                  </div>

                                  <div className="col-md-4 d-flex align-items-end justify-content-end">

                                    <button type="submit" className="btn btn-primary" onClick={(e) => handleEnter(e)}>

                                      Add Designation
                                    </button>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>

                        </div>
                        {/*  */}

                        {/* d-flex gap-2 */}

                      </div>
                      {/* Row ends */}
                      <div className="card border">

                        <div className="card-body pt-15">
                          {/* Table starts */}

                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="card-title mb-0">Department List</h5>

                            <div>
                              <button type="button" id="cancel" className="btn btn-primary me-2" style={{ display: "none" }} onClick={handleCancelDesignation}>
                                Cancel
                              </button>
                              <button type="button" id="add" className="btn btn-primary" onClick={addDesignationPanel}>
                                Add Designation
                              </button>
                            </div>
                          </div>


                          <div className="table-responsive">
                            <table id="basicExample" className="table m-0 align-middle">
                              <thead>
                                <tr>
                                  <th>#</th>

                                  <th>Department</th>
                                  <th>Designation</th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>

                                {designationTbl.map((item, index) => (
                                  <tr key={item.id}>
                                    <td>{index + 1}</td>
                                    <td>{item.departmentName}</td>
                                    <td>{item.designation}</td>
                                    <td>
                                      {/* Delete Button */}
                                      {/* <button
                                        className="btn btn-outline-danger btn-sm rounded-5 me-2"
                                        data-bs-toggle="modal"
                                        data-bs-target="#delRow"
                                        onClick={() => setDesignationToDelete(item.desigantionId)}
                                      >
                                        <i className="ri-delete-bin-line" />
                                      </button> */}

                                      {/* Edit Button */}
                                      <button
                                        className="btn btn-outline-success btn-sm"
                                        data-bs-toggle="modal"
                                        data-bs-target="#editModules"
                                        data-bs-title="Edit"
                                        onClick={() => handleEditClick(item.designationId, item.designation, item.departmentId)}

                                      >
                                        <i className="ri-edit-box-line" />
                                      </button>

                                    </td>
                                  </tr>
                                ))}
                              </tbody>


                            </table>
                          </div>
                          {/* Table ends */}
                          {/* Modal Delete Row */}
                          <div className="modal fade" id="delRow" tabIndex={-1} aria-labelledby="delRowLabel" aria-hidden="true">
                            <div className="modal-dialog modal-sm">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="delRowLabel">
                                    Confirm
                                  </h5>
                                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                </div>
                                <div className="modal-body">
                                  Are you sure you want to delete the doctor from list?
                                </div>
                                <div className="modal-footer">
                                  <div className="d-flex justify-content-end gap-2">
                                    <button className="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">No</button>
                                    <button className="btn btn-danger" data-bs-dismiss="modal" aria-label="Close" onClick={() => handleSoftDelete(designationToDelete)}>Yes</button>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* Modal Delete Row */}
                          {/* edit row */}
                          <div className="modal fade" id="editModules" tabIndex={-1} aria-labelledby="editModulesLabel" aria-hidden="true">
                            <div className="modal-dialog modal-md">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="iconRowLabel">
                                    Edit
                                  </h5>
                                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                </div>
                                <div className="modal-body">
                                  <div className="row justify-content-left">
                                    <div className="col-sm-12 col-12" id="divPanel">
                                      <div className="card border mb-3">
                                        <div className="card-body">
                                          <div className="row gx-4">
                                            <div className=" col-sm-6 col-12">
                                              <div className="mb-3">
                                                <label className="form-label" htmlFor="a2">Department</label>
                                                <input
                                                  type="text"
                                                  className="form-control mt-2"
                                                  value={editDepartmentName}
                                                  readOnly
                                                />

                                              </div>
                                            </div>
                                            <div className="col-sm-6 col-12">
                                              <div className="mb-3">
                                                <label className="form-label" htmlFor="a2">Designation</label>
                                                <input
                                                  type="text"
                                                  className="form-control mt-2"
                                                  value={editableDesignationName}
                                                  onChange={(e) => setEditableDesignationName(e.target.value)}
                                                />
                                              </div>
                                            </div>
                                           
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                                <div className="modal-footer">
                                  <div className="d-flex justify-content-end gap-2">
                                    <button className="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">No</button>

                                    <button className="btn btn-danger" data-bs-dismiss="modal" aria-label="Close" onClick={handleEditSubmit}>Edit</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Tab content ends */}
                </div>
                {/* Custom tabs ends */}
                {/* Buttons starts */}

                {/* Buttons ends */}
              </div>
            </div>
          </div>
        </div>
        {/* Row ends */}
      </div>
      {/* App body ends */}
    </div>
  );
}
export default AddDesignations;
